import { useMemo } from 'react';

import { SHAREABLE_PROFILE_PAGE } from 'src/components/Router';
import { usePage } from 'src/components/Router/usePage';

export const useShareableProfileSlug = () => {
  const page = usePage();

  return useMemo(() => {
    if (page === SHAREABLE_PROFILE_PAGE) {
      if (typeof window === 'undefined') return '';

      const matches = window.location.pathname.match(/\/profile\/(.*)$/);

      return matches ? matches[1] : '';
    }

    return '';
  }, [page]);
};
